"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3004],{

/***/ 43004:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$6": function() { return /* binding */ RECOMMEND_ICON; },
/* harmony export */   "Ax": function() { return /* binding */ MOLECULE_ICON; },
/* harmony export */   "Az": function() { return /* binding */ USER_ACTIVE; },
/* harmony export */   "BB": function() { return /* binding */ ICON_PLATINUM_RANK; },
/* harmony export */   "Cf": function() { return /* binding */ ICON_STEP_CONFIRMED; },
/* harmony export */   "D1": function() { return /* binding */ ICON_GOLD_RANK_ACTIVE; },
/* harmony export */   "DV": function() { return /* binding */ ICON_STEP_TRANSPORTING; },
/* harmony export */   "EU": function() { return /* binding */ PHONE_ICON; },
/* harmony export */   "Ej": function() { return /* binding */ ICON_FILE_CHECKED; },
/* harmony export */   "Er": function() { return /* binding */ POINTS; },
/* harmony export */   "F3": function() { return /* binding */ TIKTOK_ICON; },
/* harmony export */   "Fr": function() { return /* binding */ FACEBOOK_ICON; },
/* harmony export */   "G9": function() { return /* binding */ ICON_WISHLIST_DEL_V2; },
/* harmony export */   "Gh": function() { return /* binding */ ICON_STEP_DELIVERED; },
/* harmony export */   "HF": function() { return /* binding */ ICON_STEP_WAIT_TO_CONFIRM; },
/* harmony export */   "HT": function() { return /* binding */ ICON_VOUCHER_PROMO_TS; },
/* harmony export */   "Hq": function() { return /* binding */ PRICE_INCREASE_ICON; },
/* harmony export */   "Hz": function() { return /* binding */ DOWNLOAD_APP_ICON; },
/* harmony export */   "I2": function() { return /* binding */ VOUCHER_TITLE_TS_DETAIL; },
/* harmony export */   "Iq": function() { return /* binding */ ICON_MOBILE_ICON_RATING_STAR_NOT_FILL; },
/* harmony export */   "J2": function() { return /* binding */ CHAT; },
/* harmony export */   "J5": function() { return /* binding */ ICON_SLIVER_RANK; },
/* harmony export */   "Jp": function() { return /* binding */ QR_WHITE; },
/* harmony export */   "K6": function() { return /* binding */ BILL; },
/* harmony export */   "KB": function() { return /* binding */ PRICE_DECREASE_ICON; },
/* harmony export */   "KP": function() { return /* binding */ ICON_MOBILE_ICON_RATING_STAR; },
/* harmony export */   "KX": function() { return /* binding */ ICON_STEP_COMPLETED; },
/* harmony export */   "Ky": function() { return /* binding */ ICON_EDIT_INVOICE; },
/* harmony export */   "LB": function() { return /* binding */ ICON_FEEBACK_DETAILV2; },
/* harmony export */   "LD": function() { return /* binding */ CALENDAR_ICON; },
/* harmony export */   "LT": function() { return /* binding */ TRUCK_WHITE; },
/* harmony export */   "MY": function() { return /* binding */ IMG; },
/* harmony export */   "NX": function() { return /* binding */ BLACK_BOX_ICON; },
/* harmony export */   "Pl": function() { return /* binding */ REWARDS; },
/* harmony export */   "Q$": function() { return /* binding */ BOX_ICON; },
/* harmony export */   "QN": function() { return /* binding */ ICON_STEP_DELIVERING; },
/* harmony export */   "QR": function() { return /* binding */ QR; },
/* harmony export */   "Qv": function() { return /* binding */ ATTACH; },
/* harmony export */   "RK": function() { return /* binding */ STATISTICAL; },
/* harmony export */   "RO": function() { return /* binding */ ICON_PROFILE_ENGLISH; },
/* harmony export */   "RT": function() { return /* binding */ WISHLIST_ACTIVE; },
/* harmony export */   "RV": function() { return /* binding */ VIEWED; },
/* harmony export */   "Rr": function() { return /* binding */ MONEY_ICON_V2; },
/* harmony export */   "Sh": function() { return /* binding */ ICON_MOBILE_ICON_ATTACH_FILE; },
/* harmony export */   "Sr": function() { return /* binding */ VIEWED_WHITE; },
/* harmony export */   "Tu": function() { return /* binding */ REWARDS_ACTIVE; },
/* harmony export */   "Ue": function() { return /* binding */ VOUCHER_TITLE_BOX; },
/* harmony export */   "V$": function() { return /* binding */ LOGOUT_ICON_IMG; },
/* harmony export */   "Vy": function() { return /* binding */ SUPPORT_CENTER_ICON; },
/* harmony export */   "WT": function() { return /* binding */ ICON_UP_INVOICE; },
/* harmony export */   "Wj": function() { return /* binding */ REWARDS_WHITE; },
/* harmony export */   "YZ": function() { return /* binding */ VIEWED_ACTIVE; },
/* harmony export */   "_v": function() { return /* binding */ FEEDBACK_ACTIVE; },
/* harmony export */   "a7": function() { return /* binding */ XSL; },
/* harmony export */   "aI": function() { return /* binding */ FEEDBACK_WHITE; },
/* harmony export */   "ap": function() { return /* binding */ LINKEDIN_ICON; },
/* harmony export */   "bA": function() { return /* binding */ STATISTICAL_WHITE; },
/* harmony export */   "bL": function() { return /* binding */ ICON_MOBILE_ICON_RANK_SILVER; },
/* harmony export */   "bn": function() { return /* binding */ ICON_MOBILE_ICON_RATING_STAR_FILL; },
/* harmony export */   "bx": function() { return /* binding */ LOGOUT_ICON_WHITE_IMG; },
/* harmony export */   "cm": function() { return /* binding */ ORDER_WHITE; },
/* harmony export */   "cn": function() { return /* binding */ ICON_EDIT_ORDER_V2; },
/* harmony export */   "d$": function() { return /* binding */ ICON_RETURN_DETAILV2; },
/* harmony export */   "dd": function() { return /* binding */ WISHLIST; },
/* harmony export */   "dx": function() { return /* binding */ REFER_ACTIVE; },
/* harmony export */   "e7": function() { return /* binding */ PAPER_PLANE; },
/* harmony export */   "eu": function() { return /* binding */ FEEDBACK; },
/* harmony export */   "fP": function() { return /* binding */ USER_WHITE; },
/* harmony export */   "fj": function() { return /* binding */ ICON_STEP_EXIT; },
/* harmony export */   "fy": function() { return /* binding */ DOCS; },
/* harmony export */   "g2": function() { return /* binding */ ICON_PLATINUM_RANK_ACTIVE; },
/* harmony export */   "g3": function() { return /* binding */ STATISTICAL_ACTIVE; },
/* harmony export */   "g5": function() { return /* binding */ PDF; },
/* harmony export */   "gZ": function() { return /* binding */ ICON_MOBILE_ICON_TS_POINT; },
/* harmony export */   "gi": function() { return /* binding */ REFER_WHITE; },
/* harmony export */   "go": function() { return /* binding */ LIGHT_BLUE_LOGO; },
/* harmony export */   "gu": function() { return /* binding */ WISHLIST_IMAGE_ACTIVE; },
/* harmony export */   "i2": function() { return /* binding */ POINTS_ACTIVE; },
/* harmony export */   "id": function() { return /* binding */ QR_ACTIVE; },
/* harmony export */   "ik": function() { return /* binding */ CART_QUANTITY_ICON; },
/* harmony export */   "jE": function() { return /* binding */ ICON_PROFILE_THAI; },
/* harmony export */   "jr": function() { return /* binding */ ICON_MOBILE_ICON_WALLET; },
/* harmony export */   "jx": function() { return /* binding */ POINTS_WHITE; },
/* harmony export */   "kk": function() { return /* binding */ VOUCHER_ACTIVE; },
/* harmony export */   "kl": function() { return /* binding */ ORDER; },
/* harmony export */   "mW": function() { return /* binding */ LOYALTY_BTN_VIEW_MORE; },
/* harmony export */   "n2": function() { return /* binding */ ICON_DIAMOND_RANK; },
/* harmony export */   "nf": function() { return /* binding */ TIME; },
/* harmony export */   "o0": function() { return /* binding */ ICON_MOBILE_ICON_RANK_DIAMOND; },
/* harmony export */   "oZ": function() { return /* binding */ ICON_DIAMOND_RANK_ACTIVE; },
/* harmony export */   "op": function() { return /* binding */ LOGO_SHORT_BLUE_20; },
/* harmony export */   "pR": function() { return /* binding */ ICON_MOBILE_ICON_RANK_PLATIUM; },
/* harmony export */   "pX": function() { return /* binding */ VIDEO; },
/* harmony export */   "qr": function() { return /* binding */ MORE; },
/* harmony export */   "rC": function() { return /* binding */ ICON_MOBILE_ICON_RANK_GOLD; },
/* harmony export */   "rS": function() { return /* binding */ ICON_SLIVER_RANK_ACTIVE; },
/* harmony export */   "s$": function() { return /* binding */ ICON_AMBASSADOR_RANK; },
/* harmony export */   "sJ": function() { return /* binding */ ICON_AMBASSADOR_RANK_ACTIVE; },
/* harmony export */   "sR": function() { return /* binding */ WISHLIST_WHITE; },
/* harmony export */   "t9": function() { return /* binding */ SELLER_GRAY; },
/* harmony export */   "uB": function() { return /* binding */ VOUCHER; },
/* harmony export */   "ub": function() { return /* binding */ LUCKWHEEL_BUTTON_CLOSE_MOBILE; },
/* harmony export */   "vF": function() { return /* binding */ VOUCHER_WHITE; },
/* harmony export */   "we": function() { return /* binding */ ZALO_ICON; },
/* harmony export */   "wh": function() { return /* binding */ ICON_MOBILE_ICON_RATING_SUCCESS; },
/* harmony export */   "x4": function() { return /* binding */ VOUCHER_TITLE_TS; },
/* harmony export */   "xA": function() { return /* binding */ WISHLIST_IMAGE_INACTIVE; },
/* harmony export */   "xR": function() { return /* binding */ USER; },
/* harmony export */   "yB": function() { return /* binding */ BILL_ACTIVE; },
/* harmony export */   "yg": function() { return /* binding */ GALLERY; },
/* harmony export */   "ys": function() { return /* binding */ REFER; },
/* harmony export */   "yu": function() { return /* binding */ ICON_GOLD_RANK; },
/* harmony export */   "zA": function() { return /* binding */ ICON_STEP_PROCESSING; },
/* harmony export */   "zI": function() { return /* binding */ ORDER_ACTIVE; },
/* harmony export */   "zN": function() { return /* binding */ LINE_ICON; }
/* harmony export */ });
/* unused harmony exports TAG_LOGO_HANG_HANG, ICON_CO_O_KHO, PRODUCT_ICON, ORDER_ICON, INGREDIENT_ICON, SALE_ICON, COUPON_ICON, STORE_ICON_2, ICON_CHAT_NGAY, DOLLAR_ICON, STORE_BLUE_ICON, COLOR_STORE, NEW_PRODUCT_ICON, PDF_ICON, XLS_ICON, DOCS_ICON, VIDEO_ICON, IMG_ICON, MORE_ICON, ATTACH_ICON, PAPER_PLANE_ICON, GALLERY_ICON, LIGHT_BLUE_LOGO_ICON, TIME_ICON, SELLER_GRAY_ICON, CHAT_ICON, TELEGRAM_ICON, ICON_ARROW_RIGHT_DETAILV2, ICON_SEARCH_PROMO_MOBILE_V2, ICON_MOBILE_ICON_BACK, ICON_PROFILE_CHANGE_LANGUAGE, LUCKWHEEL_BG_BORDER, LUCKYWHEEL_BG_BORDER_WITH_CENTER, LUCKWHEEL_BG_CENTER, LUCKWHEEL_BG_ARROW_SELECTOR */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var constants_Images__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13270);
/* harmony import */ var constants_Images_default__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44776);
/* harmony import */ var constants_Images_mobile__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(93893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var sysconfig__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66225);
/* harmony import */ var utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34588);







// TODO: refactor contanst




// icons
var TAG_LOGO_HANG_HANG = "/icons/tag_logo_hang_hang.svg";
var ICON_CO_O_KHO = "/icons/icon_co_o_kho.svg";
var PRODUCT_ICON = "/icons/product.svg";
var ORDER_ICON = "/icons/order.svg";
var DOWNLOAD_APP_ICON = "/icons/download_app.svg";
var INGREDIENT_ICON = "/icons/ingredient.svg";
var SALE_ICON = "/icons/sale.svg";
var COUPON_ICON = "/icons/coupon.svg";
var STORE_ICON_2 = "/images/store_icon.png";
var ICON_CHAT_NGAY = "/images/icon_chat_ngay.svg";
var DOLLAR_ICON = "/images/icon/dollar.svg";
var MONEY_ICON_V2 = "/images/icon/money_v2.svg";
var PRICE_DECREASE_ICON = "/icons/decrease_icon.svg";
var PRICE_INCREASE_ICON = "/icons/increase_icon.svg";
var CART_QUANTITY_ICON = "/icons/cart_icon.svg";
var FACEBOOK_ICON = "/icons/facebook_icon.png";
var ZALO_ICON = "/icons/zalo_icon.png";
var TIKTOK_ICON = "/icons/tiktok_icon.png";
var LINKEDIN_ICON = "/icons/linkedin_icon.png";
var STORE_BLUE_ICON = "/images/store_blue.svg";
var COLOR_STORE = "/icons/color_seller.svg";
var NEW_PRODUCT_ICON = "/icons/new_product.svg";
var PDF_ICON = "/icons/pdf_file.svg";
var XLS_ICON = "/icons/xls_file.svg";
var DOCS_ICON = "/icons/docs_file.svg";
var VIDEO_ICON = "/icons/video_file.svg";
var IMG_ICON = "/icons/img_file.svg";
var MORE_ICON = "/icons/more_icon.svg";
var ATTACH_ICON = "/icons/attach_file.svg";
var PAPER_PLANE_ICON = "/icons/paper_plane.svg";
var GALLERY_ICON = "/icons/gallery.svg";
var LIGHT_BLUE_LOGO_ICON = "/icons/light_blue_logo.svg";
var TIME_ICON = "/orderStatus/time.svg";
var SELLER_GRAY_ICON = "/icons/seller_gray.svg";
var CHAT_ICON = "/static/images/chat/chat.svg";
var TELEGRAM_ICON = "/static/images/chat/telegram.svg";
var PHONE_ICON = "/static/images/chat/phone.svg";
var LINE_ICON = "/static/images/chat/line.svg";
var SUPPORT_CENTER_ICON = "/static/images/chat/chat-support-2.png";
var RECOMMEND_ICON = "/icons/recommend.svg";
var BOX_ICON = "/icons/box.svg";
var BLACK_BOX_ICON = "/icons/black_box.svg";
var CALENDAR_ICON = "/icons/calendar.svg";
var MOLECULE_ICON = "/icons/molecule.svg";
var TIME = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function(param) {
    var _width = param.width, width = _width === void 0 ? 12 : _width, _height = param.height, height = _height === void 0 ? 12 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: TIME_ICON,
        width: width,
        height: height
    });
});
// deprecated 22Feb2023 - Dinh Tran
// export const LOGO_SHORT_BLUE = memo(({ width = 45, height = 45 }) => (
//   <ImageFallbackStatic src={LOGO_THUOCSI_SHORTENED} width={width} height={height} />
// ));
var LIGHT_BLUE_LOGO = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function(param) {
    var _width = param.width, width = _width === void 0 ? 200 : _width, _height = param.height, height = _height === void 0 ? 200 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: LIGHT_BLUE_LOGO_ICON,
        width: width,
        height: height
    });
});
var CHAT = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function(param) {
    var _width = param.width, width = _width === void 0 ? 48 : _width, _height = param.height, height = _height === void 0 ? 48 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: CHAT_ICON,
        width: width,
        height: height
    });
});
var SELLER_GRAY = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function(param) {
    var _width = param.width, width = _width === void 0 ? 15 : _width, _height = param.height, height = _height === void 0 ? 16 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: SELLER_GRAY_ICON,
        width: width,
        height: height
    });
});
var LOGO_SHORT_BLUE_20 = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function(param) {
    var _width = param.width, width = _width === void 0 ? 20 : _width, _height = param.height, height = _height === void 0 ? 20 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .LOGO_THUOCSI_SHORTENED */ .SlS,
        width: width,
        height: height
    });
});
var PAPER_PLANE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function(_param) /*#__PURE__*/ {
    var _width = _param.width, width = _width === void 0 ? 24 : _width, _height = _param.height, height = _height === void 0 ? 24 : _height, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "width",
        "height"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, rest), {
        src: PAPER_PLANE_ICON,
        width: width,
        height: height
    }));
});
var USER = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .USER_ICON */ .YFh,
        width: "24px",
        height: "24px"
    });
});
var BILL = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .BILL_ICON */ .SLh,
        width: "26px",
        height: "21px"
    });
});
var FEEDBACK = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .FEEDBACK_ICON */ .dd6,
        width: "24px",
        height: "24px"
    });
});
var POINTS = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .POINTS_ICON */ .v2s,
        width: "20px",
        height: "24px"
    });
});
var REFER = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .REFER_FRIEND_ICON */ ._nW,
        width: "26px",
        height: "20px"
    });
});
var STATISTICAL = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .STATISTICAL_ICON */ ._kC,
        width: "24px",
        height: "24px"
    });
});
var WISHLIST = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .WISHLIST_ICON */ .wtK,
        width: "24px",
        height: "22px"
    });
});
var ORDER = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_ICON_MENU */ .N4V,
        width: "20px",
        height: "24px"
    });
});
var VIEWED = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .VIEWED_ICON */ .O$W,
        width: "24px",
        height: "20px"
    });
});
var QR = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .QR_ICON */ .W3N,
        width: "24px",
        height: "24px"
    });
});
// export const LEVEL = memo(() => <ImageFallbackStatic src={LEVEL_ICON} width="24px" height="24px" />); // deprecated 22Feb2023 - Dinh Tran
var VOUCHER = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .VOUCHER_ICON */ .oCr,
        width: "24px",
        height: "24px"
    });
});
var PDF = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function(param) {
    var _width = param.width, width = _width === void 0 ? 60 : _width, _height = param.height, height = _height === void 0 ? 60 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: PDF_ICON,
        width: width,
        height: height
    });
});
var XSL = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function(param) {
    var _width = param.width, width = _width === void 0 ? 60 : _width, _height = param.height, height = _height === void 0 ? 60 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: XLS_ICON,
        width: width,
        height: height
    });
});
var DOCS = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function(param) {
    var _width = param.width, width = _width === void 0 ? 60 : _width, _height = param.height, height = _height === void 0 ? 60 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: DOCS_ICON,
        width: width,
        height: height
    });
});
var VIDEO = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function(param) {
    var _width = param.width, width = _width === void 0 ? 60 : _width, _height = param.height, height = _height === void 0 ? 60 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: VIDEO_ICON,
        width: width,
        height: height
    });
});
var IMG = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function(param) {
    var _width = param.width, width = _width === void 0 ? 60 : _width, _height = param.height, height = _height === void 0 ? 60 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: IMG_ICON,
        width: width,
        height: height
    });
});
var MORE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: MORE_ICON,
        width: "24px",
        height: "24px"
    });
});
var ATTACH = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function(param) {
    var _width = param.width, width = _width === void 0 ? 200 : _width, _height = param.height, height = _height === void 0 ? 200 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: ATTACH_ICON,
        width: width,
        height: height
    });
});
var GALLERY = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: GALLERY_ICON,
        width: "32px",
        height: "28px"
    });
});
var LOGOUT_ICON_IMG = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .LOGOUT_ICON */ .O4y,
        width: "24px",
        height: "24px"
    });
});
var LOGOUT_ICON_WHITE_IMG = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .LOGOUT_ICON_WHITE */ .ZgI,
        width: "24px",
        height: "24px"
    });
});
var REWARDS = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .QUEST_REWARDS_ICON */ .DoS,
        width: "24px",
        height: "24px"
    });
});
// active icons
var USER_ACTIVE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .USER_ICON_ACTIVE */ .UCA,
        width: "24px",
        height: "24px"
    });
});
var BILL_ACTIVE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .BILL_ICON_ACTIVE */ .P0s,
        width: "26px",
        height: "21px"
    });
});
var ORDER_ACTIVE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_ICON_MENU_ACTIVE */ .y6j,
        width: "20px",
        height: "24px"
    });
});
var FEEDBACK_ACTIVE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .FEEDBACK_ICON_ACTIVE */ .nHV,
        width: "24px",
        height: "24px"
    });
});
var POINTS_ACTIVE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .POINTS_ICON_ACTIVE */ .tJs,
        width: "20px",
        height: "24px"
    });
});
var REFER_ACTIVE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .REFER_FRIEND_ICON_ACTIVE */ .fRq,
        width: "26px",
        height: "20px"
    });
});
var STATISTICAL_ACTIVE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .STATISTICAL_ICON_ACTIVE */ .I7K,
        width: "24px",
        height: "24px"
    });
});
var QR_ACTIVE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .QR_ICON_ACTIVE */ .h3X,
        width: "24px",
        height: "24px"
    });
});
var VIEWED_ACTIVE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .VIEWED_ICON_ACTIVE */ .H1y,
        width: "24px",
        height: "20px"
    });
});
var WISHLIST_ACTIVE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .WISHLIST_ICON_ACTIVE */ .$b5,
        width: "24px",
        height: "22px"
    });
});
// export const LEVEL_ACTIVE = memo(() => <ImageFallbackStatic src={LEVEL_ICON_ACTIVE} width="24px" height="24px" />); // deprecated 22Feb2023 - Dinh Tran
var VOUCHER_ACTIVE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .VOUCHER_ICON_ACTIVE */ .tKN,
        width: "24px",
        height: "24px"
    });
});
// icon white
var USER_WHITE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .USER_ICON_WHITE */ .gEK,
        width: "24px",
        height: "24px"
    });
});
var TRUCK_WHITE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .TRUCK_ICON_WHITE */ .B3N,
        width: "26px",
        height: "21px"
    });
});
var FEEDBACK_WHITE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .FEEDBACK_ICON_WHITE */ .UPS,
        width: "24px",
        height: "24px"
    });
});
var POINTS_WHITE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .POINTS_ICON_WHITE */ .Jix,
        width: "20px",
        height: "24px"
    });
});
var REFER_WHITE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .REFER_FRIEND_ICON_WHITE */ .OEc,
        width: "26px",
        height: "20px"
    });
});
var STATISTICAL_WHITE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .STATISTICAL_ICON_WHITE */ .bB1,
        width: "24px",
        height: "24px"
    });
});
var WISHLIST_WHITE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .WISHLIST_ICON_WHITE */ .Z$c,
        width: "24px",
        height: "22px"
    });
});
var ORDER_WHITE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_ICON_MENU_WHITE */ .fXx,
        width: "20px",
        height: "24px"
    });
});
var VIEWED_WHITE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .VIEWED_ICON_WHITE */ .L7K,
        width: "24px",
        height: "20px"
    });
});
var QR_WHITE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .QR_ICON_WHITE */ .DEp,
        width: "24px",
        height: "24px"
    });
});
// export const LEVEL_WHITE = memo(() => <ImageFallbackStatic src={LEVEL_ICON_WHITE} width="24px" height="24px" />); // deprecated 22Feb2023 - Dinh Tran
var VOUCHER_WHITE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .VOUCHER_ICON_WHITE */ .W0F,
        width: "24px",
        height: "24px"
    });
});
var REWARDS_WHITE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .QUEST_REWARDS_ICON_WHITE */ .Rvt,
        width: "24px",
        height: "22px"
    });
});
var REWARDS_ACTIVE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .QUEST_REWARDS_ICON_ACTIVE */ .pHD,
        width: "24px",
        height: "22px"
    });
});
var WISHLIST_IMAGE_INACTIVE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .WISHLIST_ICON_1 */ .kvq,
        width: 24,
        height: 24
    });
});
var WISHLIST_IMAGE_ACTIVE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .WISHLIST_ICON_4 */ .fPw,
        width: 24,
        height: 24
    });
});
// LOYALTY VOUCHER V2
var VOUCHER_TITLE_BOX = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .VOUHCER_PROMOTION_BOX */ .fcB,
        width: 20,
        height: 23
    });
});
var VOUCHER_TITLE_TS_DETAIL = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .VOUCHER_TITLE_DETAIL */ .Smv,
        width: 15,
        height: 16
    });
});
var VOUCHER_TITLE_TS = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .VOUCHER_TITLE */ .$bV,
        width: 27,
        height: 24
    });
});
// export const VOUCHER_TITLE_TS_GREEN = memo(() => <ImageFallbackStatic src={VOUCHER_TITLE_GREEN} width={24} height={24} />); // deprecated 22Feb2023 - Dinh Tran
var LOYALTY_BTN_VIEW_MORE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .LOYALTY_ARROW_VIEW_MORE */ .DDT,
        width: 9,
        height: 11
    });
});
// export const ARROW_ORDER = memo(() => <ImageFallbackStatic src={ICON_ARROW_ORDER} width={18} height={17} />); // deprecated 22Feb2023 - Dinh Tran
// export const ARROW_ORDER_ACTIVE = memo(() => <ImageFallbackStatic sec={ICON_ARROW_ORDER_ACTIVE} width={18} height={17} />); // deprecated 22Feb2023 - Dinh Tran
// order detail v2 icon
var ICON_FILE_CHECKED = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .I_FILE_CHECKED */ .ekk,
        width: 20,
        height: 20
    });
});
// export const ICON_RE_ORDERV2 = memo(() => <ImageFallbackStatic src={ReAddToCartV2} width={28} height={28} />); // deprecated 22Feb2023 - Dinh Tran
// export const ICON_EDIT_V2 = memo(() => <ImageFallbackStatic src={EditDetailV2} width={28} height={28} />); // deprecated 22Feb2023 - Dinh Tran
var ICON_EDIT_ORDER_V2 = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .I_EDIT_ORDER_V2 */ .O7y,
        width: 16,
        height: 16
    });
});
var ICON_STEP_WAIT_TO_CONFIRM = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .I_WAIT_TO_CONFIRM */ .Erc,
        width: 20,
        height: 20,
        priority: true
    });
});
var ICON_STEP_PROCESSING = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .I_PROCESSING_V2 */ .Cln,
        width: 20,
        height: 20,
        priority: true
    });
});
var ICON_STEP_DELIVERING = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .I_DELIVERING */ .cvC,
        width: 20,
        height: 20,
        priority: true
    });
});
var ICON_STEP_DELIVERED = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .I_DELIVERED */ .wMq,
        width: 20,
        height: 20,
        priority: true
    });
});
var ICON_STEP_TRANSPORTING = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .I_TRANSPORTING */ .lNb,
        width: 20,
        height: 20,
        priority: true
    });
});
var ICON_STEP_CONFIRMED = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .I_CONFIRMED */ .Tzo,
        width: 20,
        height: 20,
        priority: true
    });
});
var ICON_STEP_COMPLETED = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .I_COMPLETED */ .PKp,
        width: 20,
        height: 20,
        priority: true
    });
});
var ICON_STEP_EXIT = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .I_EXIT */ .fGn,
        width: 20,
        height: 20,
        priority: true
    });
});
var ICON_FEEBACK_DETAILV2 = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .I_FEEDBACK_DETAILV2 */ .flC,
        width: 14,
        height: 15
    });
});
var ICON_RETURN_DETAILV2 = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .I_RETURN_ORDER_DETAILV2 */ .wfH,
        width: 15,
        height: 17
    });
});
var ICON_ARROW_RIGHT_DETAILV2 = /*#__PURE__*/ (/* unused pure expression or super */ null && (memo(function() {
    return /*#__PURE__*/ _jsx(ImageFallbackStatic, {
        src: I_ARROW_RIGHT_DETAILV2,
        width: 20,
        height: 20
    });
})));
var ICON_EDIT_INVOICE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .EDIT_INVOICE */ .P_R,
        width: 16,
        height: 16
    });
});
var ICON_UP_INVOICE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .UP_INVOICE */ .zyx,
        width: 16,
        height: 16
    });
});
var ICON_SLIVER_RANK = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .SLIVER_ICON_RANK */ .cfK,
        width: 25,
        height: 24,
        priority: true
    });
});
var ICON_GOLD_RANK = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .GOLD_ICON_RANK */ .jp6,
        width: 24,
        height: 24,
        priority: true
    });
});
var ICON_PLATINUM_RANK = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .PLATINUM_ICON_RANK */ .$rc,
        width: 24,
        height: 24,
        priority: true
    });
});
var ICON_DIAMOND_RANK = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .DIAMOND_ICON_RANK */ .YnC,
        width: 24,
        height: 24,
        priority: true
    });
});
var ICON_DIAMOND_RANK_ACTIVE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .DIAMOND_ICON_RANK_ACTIVE */ .jkw,
        width: 24,
        height: 24,
        priority: true
    });
});
var ICON_SLIVER_RANK_ACTIVE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .SLIVER_ICON_RANK_ACTIVE */ .Vf$,
        width: 24,
        height: 24,
        priority: true
    });
});
var ICON_GOLD_RANK_ACTIVE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .GOLD_ICON_RANK_ACTIVE */ .Dnl,
        width: 24,
        height: 24,
        priority: true
    });
});
var ICON_PLATINUM_RANK_ACTIVE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .PLATINUM_ICON_RANK_ACTIVE */ .p9V,
        width: 24,
        height: 24,
        priority: true
    });
});
var ICON_AMBASSADOR_RANK_ACTIVE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .AMBASSADOR_ICON_RANK_ACTIVE */ .PfJ,
        width: 24,
        height: 24,
        priority: true
    });
});
var ICON_AMBASSADOR_RANK = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .AMBASSADOR_ICON_RANK */ .CyI,
        width: 24,
        height: 24,
        priority: true
    });
});
// cart -> poup promo
var ICON_VOUCHER_PROMO_TS = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return sysconfig__WEBPACK_IMPORTED_MODULE_5__/* .ENV_COUNTRY */ .ng === "vn" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .VOUCHER_TS_PROMO */ .$l0,
        width: 108,
        height: 19,
        priority: true
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
        src: constants_Images_default__WEBPACK_IMPORTED_MODULE_2__/* .LOGO_BUYMED_GG */ .dV,
        width: 108,
        height: 27
    });
});
var ICON_SEARCH_PROMO_MOBILE_V2 = /*#__PURE__*/ (/* unused pure expression or super */ null && (memo(function() {
    return /*#__PURE__*/ _jsx(ImageFallbackStatic, {
        src: SEARCHV2_ICON,
        width: 22,
        height: 22,
        priority: true
    });
})));
// moible icon
var ICON_MOBILE_ICON_BACK = /*#__PURE__*/ (/* unused pure expression or super */ null && (memo(function() {
    return /*#__PURE__*/ _jsx(ImageFallbackStatic, {
        src: MOBILE_ICON_BACK,
        width: 24,
        height: 24,
        priority: true
    });
})));
var ICON_MOBILE_ICON_RANK_DIAMOND = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
        src: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_10__/* .MOBILE_ICON_RANK_DIAMOND */ .KW,
        width: 24,
        height: 24,
        priority: true
    });
});
var ICON_MOBILE_ICON_RANK_GOLD = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
        src: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_10__/* .MOBILE_ICON_RANK_GOLD */ .NH,
        width: 24,
        height: 24,
        priority: true
    });
});
var ICON_MOBILE_ICON_RANK_PLATIUM = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
        src: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_10__/* .MOBILE_ICON_RANK_PLATIUM */ .i5,
        width: 24,
        height: 24,
        priority: true
    });
});
var ICON_MOBILE_ICON_RANK_SILVER = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
        src: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_10__/* .MOBILE_ICON_RANK_SILVER */ .iB,
        width: 24,
        height: 24,
        priority: true
    });
});
var ICON_MOBILE_ICON_TS_POINT = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
        src: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_10__/* .MOBILE_ICON_TS_POINT */ .ov,
        width: 24,
        height: 24,
        priority: true
    });
});
var ICON_MOBILE_ICON_WALLET = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
        src: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_10__/* .MOBILE_ICON_WALLET */ .ss,
        width: 24,
        height: 24,
        priority: true
    });
});
// export const ICON_MOBILE_ICON_ALERT_SUCCESS = memo(() => <Image src={MOBILE_ICON_ALERT_SUCCESS} width={60} height={60} priority />); // deprecated 22Feb2023 - Dinh Tran
// export const ICON_MOBILE_ICON_ALERT_WARNING = memo(() => <Image src={MOBILE_ICON_ALERT_SUCCESS} width={60} height={60} priority />); // deprecated 22Feb2023 - Dinh Tran
var ICON_MOBILE_ICON_RATING_STAR = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .MOBILE_ICON_RATING_STAR */ .yU,
        width: 30,
        height: 30,
        priority: true
    });
});
var ICON_MOBILE_ICON_RATING_STAR_FILL = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .MOBILE_ICON_RATING_STAR_FILL */ .CkC,
        width: 30,
        height: 30,
        priority: true
    });
});
var ICON_MOBILE_ICON_RATING_STAR_NOT_FILL = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .MOBILE_ICON_RATING_STAR_NOT_FILL */ .Ajr,
        width: 30,
        height: 30,
        priority: true
    });
});
var ICON_MOBILE_ICON_RATING_SUCCESS = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .MOBILE_ICON_RATING_SUCCESS */ .Dmq,
        width: 32,
        height: 32,
        priority: true
    });
});
var ICON_MOBILE_ICON_ATTACH_FILE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .MOBILE_ICON_ATTACH_FILE */ .vGY,
        width: 32,
        height: 32,
        priority: true
    });
});
// wishlist v2
var ICON_WISHLIST_DEL_V2 = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .I_WISHLIST_DEL */ .OaF,
        width: 19,
        height: 22,
        priority: true
    });
});
// toggle profile
var ICON_PROFILE_CHANGE_LANGUAGE = /*#__PURE__*/ (/* unused pure expression or super */ null && (memo(function() {
    return /*#__PURE__*/ _jsx(ImageFallbackStatic, {
        src: PROFILE_CHANGE_LANGUAGE,
        width: 20,
        height: 20
    });
})));
var ICON_PROFILE_ENGLISH = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .PROFILE_ENGLISH */ .NdN,
        width: 20,
        height: 20
    });
});
var ICON_PROFILE_THAI = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .PROFILE_THAI */ .FfZ,
        width: 20,
        height: 20
    });
});
// lucky wheel
var LUCKWHEEL_BG_BORDER = /*#__PURE__*/ (/* unused pure expression or super */ null && (memo(function() {
    return /*#__PURE__*/ _jsx(ImageFallbackStatic, {
        src: LUCKYWHEEL_BORDER,
        width: 200,
        height: 200,
        priority: true
    });
})));
var LUCKYWHEEL_BG_BORDER_WITH_CENTER = /*#__PURE__*/ (/* unused pure expression or super */ null && (memo(function() {
    return /*#__PURE__*/ _jsx(ImageFallbackStatic, {
        src: LUCKYWHEEL_BORDER_WITH_CENTER,
        width: 200,
        height: 200,
        priority: true
    });
})));
var LUCKWHEEL_BG_CENTER = /*#__PURE__*/ (/* unused pure expression or super */ null && (memo(function() {
    return /*#__PURE__*/ _jsx(ImageFallbackStatic, {
        src: LUCKYWHEEL_CENTER,
        width: 200,
        height: 200,
        priority: true
    });
})));
var LUCKWHEEL_BG_ARROW_SELECTOR = /*#__PURE__*/ (/* unused pure expression or super */ null && (memo(function() {
    return /*#__PURE__*/ _jsx(ImageFallbackStatic, {
        src: LUCKYWHEEL_ARROW_SELECTOR,
        width: 200,
        height: 200,
        priority: true
    });
})));
var LUCKWHEEL_BUTTON_CLOSE_MOBILE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .LUCKYWHEEL_MOBILE_CLOSE_BUTTON */ .X9M,
        width: 26,
        height: 26,
        priority: true
    });
});


/***/ }),

/***/ 93893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B9": function() { return /* binding */ MOBILE_ICON_EMPTY_CHAT; },
/* harmony export */   "BL": function() { return /* binding */ MOBILE_DOUBLE_ARROW_RIGHT; },
/* harmony export */   "Bh": function() { return /* binding */ MOBILE_ICON_SEARCH_WHITE; },
/* harmony export */   "C6": function() { return /* binding */ M_EYE_ICON; },
/* harmony export */   "EC": function() { return /* binding */ MOBILE_ICON_HOME; },
/* harmony export */   "EU": function() { return /* binding */ PHONE_ICON; },
/* harmony export */   "HO": function() { return /* binding */ INGREDIENT_ICON; },
/* harmony export */   "He": function() { return /* binding */ MOBILE_VOUCHER_ICON; },
/* harmony export */   "IL": function() { return /* binding */ MOBILE_ICON_FOR_YOU; },
/* harmony export */   "Ib": function() { return /* binding */ MOBILE_ICON_SORT_PRICE_DESC; },
/* harmony export */   "KW": function() { return /* binding */ MOBILE_ICON_RANK_DIAMOND; },
/* harmony export */   "KX": function() { return /* binding */ CONTACT_ICON; },
/* harmony export */   "Kh": function() { return /* binding */ MOBILE_ICON_BACK; },
/* harmony export */   "Ln": function() { return /* binding */ ORDER_ICON; },
/* harmony export */   "Mn": function() { return /* binding */ MOBILE_ICON_DEAL; },
/* harmony export */   "NH": function() { return /* binding */ MOBILE_ICON_RANK_GOLD; },
/* harmony export */   "PL": function() { return /* binding */ COUPON_ICON; },
/* harmony export */   "QJ": function() { return /* binding */ MOBILE_ICON_SORT_NAME_DESC; },
/* harmony export */   "Qg": function() { return /* binding */ MOBILE_ICON_SENDING; },
/* harmony export */   "RD": function() { return /* binding */ QUESTION_ICON; },
/* harmony export */   "T7": function() { return /* binding */ MOBILE_ICON_SLIDE_ARROW_RIGHT; },
/* harmony export */   "U0": function() { return /* binding */ MOBILE_ICON_AVATAR_CS; },
/* harmony export */   "U3": function() { return /* binding */ MOBILE_ICON_DISCOVERY; },
/* harmony export */   "UI": function() { return /* binding */ MOBILE_ICON_SEARCH; },
/* harmony export */   "Un": function() { return /* binding */ HEART_ICON; },
/* harmony export */   "VO": function() { return /* binding */ MOBILE_ICON_FILTER; },
/* harmony export */   "Vj": function() { return /* binding */ MOBILE_ICON_SORT_HOT_SALE; },
/* harmony export */   "ao": function() { return /* binding */ MOBILE_ICON_SORT_NEWEST; },
/* harmony export */   "bv": function() { return /* binding */ POINT_ACCUMULATING_ICON; },
/* harmony export */   "cK": function() { return /* binding */ CHAT_ICON; },
/* harmony export */   "dU": function() { return /* binding */ PRODUCT_ICON; },
/* harmony export */   "eN": function() { return /* binding */ MOBILE_ICON_SLIDE_ARROW_LEFT; },
/* harmony export */   "ft": function() { return /* binding */ MOBILE_ICON_SENT; },
/* harmony export */   "hr": function() { return /* binding */ INSIGHT_ICON; },
/* harmony export */   "i5": function() { return /* binding */ MOBILE_ICON_RANK_PLATIUM; },
/* harmony export */   "iB": function() { return /* binding */ MOBILE_ICON_RANK_SILVER; },
/* harmony export */   "kH": function() { return /* binding */ MOBILE_ICON_SORT_NAME_ASC; },
/* harmony export */   "lS": function() { return /* binding */ INFO_ICON; },
/* harmony export */   "lZ": function() { return /* binding */ MOBILE_ICON_SORT_PRICE_ASC; },
/* harmony export */   "m3": function() { return /* binding */ MOBILE_ICON_QUICK_ORDER; },
/* harmony export */   "oO": function() { return /* binding */ ICON_MOBILE_LOGO; },
/* harmony export */   "ov": function() { return /* binding */ MOBILE_ICON_TS_POINT; },
/* harmony export */   "qe": function() { return /* binding */ MOBILE_USER_ICON; },
/* harmony export */   "rx": function() { return /* binding */ TRUCK_ICON; },
/* harmony export */   "ss": function() { return /* binding */ MOBILE_ICON_WALLET; },
/* harmony export */   "wp": function() { return /* binding */ HAND_SHAKE_ICON; },
/* harmony export */   "x7": function() { return /* binding */ RESEARCH_INFO_ICON; },
/* harmony export */   "zG": function() { return /* binding */ BUSINESS_ICON; },
/* harmony export */   "zq": function() { return /* binding */ SIGN_OUT_ICON; }
/* harmony export */ });
/* unused harmony exports MOBILE_ICON_CART, MOBILE_ICON_STORE, MOBILE_ICON_COUPON, MOBILE_ICON_PRODUCT, DAILY_PROMOTION_ICON, NEWPRD_ICON, LIKE_ICON, MOBILE_ICON_SORT, MOBILE_ICON_ALERT_WARNING, MOBILE_ICON_ALERT_SUCCESS, MOBILE_ICON_CHAT */
var ICON_MOBILE_LOGO = "/thuocsi_short.svg";
var MOBILE_ICON_CART = "/images/mobile/cart.svg";
var MOBILE_ICON_DEAL = "/images/mobile/deal.svg";
var MOBILE_ICON_DISCOVERY = "/images/mobile/discover.svg";
var MOBILE_ICON_QUICK_ORDER = "/images/mobile/quick_order.svg";
var MOBILE_ICON_FOR_YOU = "/images/mobile/for_you.svg";
var MOBILE_ICON_STORE = "/images/mobile/store.svg";
var MOBILE_ICON_HOME = "/images/mobile/home.svg";
var MOBILE_ICON_COUPON = "/images/mobile/coupon.svg";
var MOBILE_ICON_PRODUCT = "/images/mobile/product.svg";
var MOBILE_ICON_BACK = "/images/mobile/back.svg";
var MOBILE_ICON_SEARCH = "/images/mobile/search.svg";
var MOBILE_ICON_RANK_DIAMOND = "/images/mobile/account/rank/diamond_rank.svg";
var MOBILE_ICON_RANK_GOLD = "/images/mobile/account/rank/gold_rank.svg";
var MOBILE_ICON_RANK_PLATIUM = "/images/mobile/account/rank/platium_rank.svg";
var MOBILE_ICON_RANK_SILVER = "/images/mobile/account/rank/silver_rank.svg";
var MOBILE_ICON_TS_POINT = "/images/mobile/ts_point.svg";
var MOBILE_ICON_WALLET = "/images/mobile/wallet.svg";
var BUSINESS_ICON = "/images/mobile/userinfo/business_icon.svg";
var CHAT_ICON = "/images/mobile/userinfo/chat_icon.svg";
var CONTACT_ICON = "/images/mobile/userinfo/contact_icon.svg";
var M_EYE_ICON = "/images/mobile/userinfo/eye_icon.svg";
var HAND_SHAKE_ICON = "/images/mobile/userinfo/hand_shake_icon.svg";
var HEART_ICON = "/images/mobile/userinfo/heart_icon.svg";
var INSIGHT_ICON = "/images/mobile/userinfo/insight_icon.svg";
var ORDER_ICON = "/images/mobile/userinfo/order_icon.svg";
var PHONE_ICON = "/images/mobile/userinfo/phone_icon.svg";
var POINT_ACCUMULATING_ICON = "/images/mobile/userinfo/point_accumulating_icon.svg";
var QUESTION_ICON = "/images/mobile/userinfo/question_icon.svg";
var RESEARCH_INFO_ICON = "/images/mobile/userinfo/research_info_icon.svg";
var SIGN_OUT_ICON = "/images/mobile/userinfo/sign_out_icon.svg";
var TRUCK_ICON = "/images/mobile/userinfo/truck_icon.svg";
var MOBILE_USER_ICON = "/images/mobile/userinfo/user_icon.svg";
var MOBILE_VOUCHER_ICON = "/images/mobile/userinfo/voucher_icon.svg";
var MOBILE_ICON_SEARCH_WHITE = "/images/mobile/search_white.svg";
// export const ARROW_PRICE_ICON = '/icons/mobile/arrow_price_icon.png';
var COUPON_ICON = "/icons/mobile/coupon_icon.svg";
// export const GIFT_ICON = '/icons/mobile/gift_icon.svg';
var DAILY_PROMOTION_ICON = "/icons/mobile/home/daily_promotion_icon.svg";
// export const EVENT_ICON = '/icons/mobile/home/event_icon.svg';
// export const FLASHSALE_ICON = '/icons/mobile/home/flashsale_icon.svg';
var NEWPRD_ICON = "/icons/mobile/home/newprd_icon.svg";
// export const SELLER_ICON = '/icons/mobile/home/seller_icon.svg';
var INGREDIENT_ICON = "/icons/mobile/ingredient_icon.svg";
var PRODUCT_ICON = "/icons/mobile/product_icon.svg";
// export const STORE_ICON = '/icons/mobile/store_icon.png';
// export const ADDITIONAL_ICON = '/icons/mobile/tags/additional_icon.png';
// export const ARROW_ICON = '/icons/mobile/tags/arrow_icon.png';
// export const DOCUMENT_ICON = '/icons/mobile/tags/document_icon.png';
// export const INGRADIENT_ICON = '/icons/mobile/tags/ingradient_icon.png';
var LIKE_ICON = "/icons/mobile/tags/like_icon.svg";
// export const TARGET_ICON = '/icons/mobile/tags/target_icon.png';
// export const DOCUMENT_ICON2 = '/icons/mobile/userinfo/document_icon.svg';
// export const EYE_ICON = '/icons/mobile/userinfo/eye_icon.svg';
var INFO_ICON = "/icons/mobile/userinfo/info_icon.svg";
// export const LEVEL_ICON = '/icons/mobile/userinfo/level_icon.svg';
var MOBILE_ICON_SORT = "/icons/mobile/sort.svg";
var MOBILE_ICON_FILTER = "/icons/mobile/filter.svg";
var MOBILE_ICON_ALERT_WARNING = "/icons/mobile/alert/warning.svg";
var MOBILE_ICON_ALERT_SUCCESS = "/icons/mobile/alert/success.svg";
// export const MOBILE_ICON_ARROW_DOWN = '/icons/mobile/arrow_down.svg';
var MOBILE_DOUBLE_ARROW_RIGHT = "/icons/mobile/store/double_arrow_right.svg";
var MOBILE_ICON_SLIDE_ARROW_RIGHT = "/icons/mobile/store/slider_right_arrow.svg";
var MOBILE_ICON_SLIDE_ARROW_LEFT = "/icons/mobile/store/slider_left_arrow.svg";
var MOBILE_ICON_SORT_HOT_SALE = "/icons/mobile/products/sort/hot-sale.svg";
var MOBILE_ICON_SORT_NEWEST = "/icons/mobile/products/sort/newest.svg";
var MOBILE_ICON_SORT_PRICE_ASC = "/icons/mobile/products/sort/price-asc.svg";
var MOBILE_ICON_SORT_PRICE_DESC = "/icons/mobile/products/sort/price-desc.svg";
var MOBILE_ICON_SORT_NAME_ASC = "/icons/mobile/products/sort/name-asc.svg";
var MOBILE_ICON_SORT_NAME_DESC = "/icons/mobile/products/sort/name-desc.svg";
// export const MOBILE_ICON_DOTS = '/icons/mobile/chat/dot.svg';
var MOBILE_ICON_AVATAR_CS = "/icons/mobile/chat/avatar_cs.svg";
var MOBILE_ICON_CHAT = "/icons/mobile/chat/icon_chat.svg";
var MOBILE_ICON_EMPTY_CHAT = "/icons/mobile/chat/icon_empty_message.svg";
var MOBILE_ICON_SENT = "/icons/mobile/chat/sent.svg";
var MOBILE_ICON_SENDING = "/icons/mobile/chat/sending.svg";


/***/ })

}]);